import React from "react";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";
import Contact from "../components/Sections/Contact";
import SEO from "../components/SEO";

export default function ContactPage() {
  return (
    <>
      <SEO title="Contact Us" description="Contact Sare Auctioneers by phone or email about property auctions and services in Kenya." />
      <TopNavbar />
      <Contact standalone />
      <Footer />
    </>
  );
}
